import { useChannelTalk } from '@repo/channel-talk';
import { DialogData } from '@repo/ui';
import { useRouter } from 'next/router';

import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { COMMON_PATHS } from '@/lib/constants/paths';

export const useSurveyErrorDialogAttributes = () => {
  const router = useRouter();
  const { openChannelTalk } = useChannelTalk();

  const alreadyCompleted: DialogData = {
    title: '이미 답변을 제출 완료했어요',
    description: '제휴 세무사가 검토를 진행할게요.\n진행 과정은 알림톡으로 안내해드릴게요.',
    buttons: {
      secondary: {
        variant: 'tonal-secondary',
        text: '문의하기',
        onClick: () => {
          openChannelTalk(SUPPORT_BOT_LINK.home);
        }
      },
      primary: {
        text: '홈으로',
        onClick: () => {
          router.push(COMMON_PATHS.환급조회목록);
        }
      }
    }
  };

  const invalidSurveyData: DialogData = {
    title: '답변을 확인해주세요.'
  };

  return {
    alreadyCompleted,
    invalidSurveyData
  };
};
